import { compact } from 'lodash-es';
import { relationshipModel } from '~/models';
import { customPagesEnabled, sortedPages } from '~/models/custom-page/model';
export const stepsTextsPath = 'clientFlow.steps';
// ============ Enums ============
export var PreviewState = /*#__PURE__*/ function(PreviewState) {
    PreviewState["Preview"] = "preview";
    PreviewState["SetupBrand"] = "setupBrand";
    return PreviewState;
}({});
export var COBStep = /*#__PURE__*/ function(COBStep) {
    COBStep["welcome"] = "welcome";
    COBStep["selectAPackage"] = "packages";
    COBStep["reviewServices"] = "services";
    COBStep["termsOfService1"] = "terms-of-service-1";
    COBStep["termsOfService2"] = "terms-of-service-2";
    COBStep["termsOfService3"] = "terms-of-service-3";
    COBStep["termsOfService4"] = "terms-of-service-4";
    COBStep["approveTerms"] = "terms";
    COBStep["accountantAccess"] = "accountant-access";
    COBStep["paymentMethod"] = "payment-method";
    COBStep["introVideo"] = "intro-video";
    COBStep["allSet"] = "all-set";
    COBStep["introduction"] = "introduction";
    COBStep["signAndApprove"] = "sign-and-approve";
    COBStep["customPage1"] = "custom-page-1";
    COBStep["customPage2"] = "custom-page-2";
    COBStep["customPage3"] = "custom-page-3";
    COBStep["customPage4"] = "custom-page-4";
    COBStep["customPage5"] = "custom-page-5";
    COBStep["customPage6"] = "custom-page-6";
    COBStep["customPage7"] = "custom-page-7";
    COBStep["customPage8"] = "custom-page-8";
    COBStep["customPage9"] = "custom-page-9";
    COBStep["customPage10"] = "custom-page-10";
    return COBStep;
}({});
export const termsOfServiceStepIndex = {
    ["terms-of-service-1"]: 0,
    ["terms-of-service-2"]: 1,
    ["terms-of-service-3"]: 2,
    ["terms-of-service-4"]: 3
};
const allCustomPageSteps = [
    "custom-page-1",
    "custom-page-2",
    "custom-page-3",
    "custom-page-4",
    "custom-page-5",
    "custom-page-6",
    "custom-page-7",
    "custom-page-8",
    "custom-page-9",
    "custom-page-10"
];
export const customPageStepIndex = {
    ["custom-page-1"]: 0,
    ["custom-page-2"]: 1,
    ["custom-page-3"]: 2,
    ["custom-page-4"]: 3,
    ["custom-page-5"]: 4,
    ["custom-page-6"]: 5,
    ["custom-page-7"]: 6,
    ["custom-page-8"]: 7,
    ["custom-page-9"]: 8,
    ["custom-page-10"]: 9
};
export const customPageStep = (index)=>allCustomPageSteps[index];
export const isCustomPageStep = (step)=>step in customPageStepIndex;
// ============ Shared Functions ============
export function getStepName(step, relationship, texts) {
    const getTermsOfServiceName = (index)=>{
        var _relationship_legalTermsDocuments_index, _relationship_legalTermsDocuments;
        const termsName = (_relationship_legalTermsDocuments = relationship.legalTermsDocuments) === null || _relationship_legalTermsDocuments === void 0 ? void 0 : (_relationship_legalTermsDocuments_index = _relationship_legalTermsDocuments[index]) === null || _relationship_legalTermsDocuments_index === void 0 ? void 0 : _relationship_legalTermsDocuments_index.displayName.replace(/\.pdf$/i, '');
        if (termsName) {
            return texts.reviewTermsWithName({
                termsName
            });
        }
        return texts.reviewTermsOfService();
    };
    switch(step){
        case "welcome":
        case "introduction":
            return texts.introduction();
        case "packages":
            return texts.selectAPackage();
        case "services":
            return texts.reviewServices();
        case "terms":
            return texts.approveTerms();
        case "accountant-access":
            return texts.accountantAccess();
        case "payment-method":
            return texts.paymentMethod();
        case "all-set":
            return texts.allSet();
        case "intro-video":
            return texts.introVideo();
        case "sign-and-approve":
            return texts.signAndApprove();
        case "terms-of-service-1":
            return getTermsOfServiceName(0);
        case "terms-of-service-2":
            return getTermsOfServiceName(1);
        case "terms-of-service-3":
            return getTermsOfServiceName(2);
        case "terms-of-service-4":
            return getTermsOfServiceName(3);
        default:
            {
                if (isCustomPageStep(step)) {
                    var _relationship_customPages, _ref;
                    var _pages_index;
                    const index = customPageStepIndex[step];
                    const pages = sortedPages((_relationship_customPages = relationship.customPages) !== null && _relationship_customPages !== void 0 ? _relationship_customPages : []);
                    return (_ref = (_pages_index = pages[index]) === null || _pages_index === void 0 ? void 0 : _pages_index.pageTitle) !== null && _ref !== void 0 ? _ref : texts.customPage();
                }
                return '';
            }
    }
}
export function getCommonReachableSteps(relationship) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _relationship_customPages, _ref;
    var _relationship_legalTermsDocuments;
    const cpEnabled = customPagesEnabled(!!options.customPagesFFEnabled, (_relationship_customPages = relationship.customPages) !== null && _relationship_customPages !== void 0 ? _relationship_customPages : [], relationship.introVideo);
    const hasPaymentMethod = relationship.requirePaymentMethod || relationship.isSample;
    const hasPackages = !!relationship.serviceBundles;
    const termsOfServiceSteps = [
        "terms-of-service-1",
        "terms-of-service-2",
        "terms-of-service-3",
        "terms-of-service-4"
    ];
    const termsOfServiceCount = (_ref = (_relationship_legalTermsDocuments = relationship.legalTermsDocuments) === null || _relationship_legalTermsDocuments === void 0 ? void 0 : _relationship_legalTermsDocuments.length) !== null && _ref !== void 0 ? _ref : 0;
    while(termsOfServiceSteps.length > termsOfServiceCount){
        termsOfServiceSteps.pop();
    }
    const customPageSteps = [];
    if (cpEnabled) {
        var _relationship_customPages1;
        const pages = sortedPages((_relationship_customPages1 = relationship.customPages) !== null && _relationship_customPages1 !== void 0 ? _relationship_customPages1 : []);
        pages.forEach((_, index)=>{
            const step = customPageStep(index);
            if (step != null) {
                customPageSteps.push(step);
            }
        });
    }
    return compact([
        !cpEnabled && relationshipModel.hasIntroVideos(relationship) && "intro-video",
        ...customPageSteps,
        hasPackages && "packages",
        "services",
        ...termsOfServiceSteps,
        "terms",
        hasPaymentMethod && "payment-method"
    ]);
}
